import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Clock, MapPin, Phone } from 'lucide-react';
import Logo from './Logo';
import { business, categories, hpServices } from '../mock/mock';

export default function Footer() {
  const p = useLocation().pathname;
  const isFloors = p === '/floors' || p.startsWith('/flooring') || p.startsWith('/mobile-showroom') || p.startsWith('/about') || p.startsWith('/reviews');
  const division = isFloors ? 'floors' : 'homepros';

  return (
    <footer className="bg-brand-charcoal text-brand-sand">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo variant="light" division={division} />
            <p className="mt-5 text-sm leading-relaxed text-brand-sand/70 max-w-xs">
              Your local one-stop home team — repairs, painting, remodeling, and our dedicated Monti Floors mobile showroom.
            </p>
            <div className="flex gap-3 mt-6">
              {business.socials.map((s) => (
                <a key={s.name} href={s.href} className="w-9 h-9 rounded-full border border-brand-sand/25 flex items-center justify-center text-xs font-medium hover:bg-brand-clay hover:border-brand-clay hover:text-white transition-colors">
                  {s.name[0]}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-brand-ivory font-display text-lg mb-4">Home Pros</h4>
            <ul className="space-y-2.5 text-sm">
              {hpServices.filter((s) => !s.to).slice(0, 6).map((s) => (
                <li key={s.title}>
                  <a href="/#services" className="text-brand-sand/70 hover:text-brand-clay transition-colors">{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-brand-ivory font-display text-lg mb-4">Monti Floors</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/floors" className="text-brand-sand/70 hover:text-brand-clay transition-colors">Flooring Home</Link></li>
              {categories.slice(0, 4).map((c) => (
                <li key={c.slug}>
                  <Link to={`/flooring/${c.slug}`} className="text-brand-sand/70 hover:text-brand-clay transition-colors">{c.name}</Link>
                </li>
              ))}
              <li><Link to="/mobile-showroom" className="text-brand-sand/70 hover:text-brand-clay transition-colors">Mobile Showroom</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-brand-ivory font-display text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-brand-clay mt-0.5 shrink-0" />
                <a href={business.phoneHref} className="hover:text-brand-clay transition-colors">{business.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-brand-clay mt-0.5 shrink-0" />
                <a href={`mailto:${business.email}`} className="hover:text-brand-clay transition-colors">{business.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-brand-clay mt-0.5 shrink-0" />
                <span className="text-brand-sand/70">{business.serviceArea}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="text-brand-clay mt-0.5 shrink-0" />
                <span className="text-brand-sand/70">Mon–Fri 9–6 · Sat 10–4</span>
              </li>
            </ul>
            <div className="mt-5 flex gap-2">
              <Link to="/" className="px-3 py-1.5 rounded-full border border-brand-sand/25 text-xs font-medium hover:bg-brand-clay hover:border-brand-clay hover:text-white transition-colors">Home Pros</Link>
              <Link to="/floors" className="px-3 py-1.5 rounded-full border border-brand-sand/25 text-xs font-medium hover:bg-brand-clay hover:border-brand-clay hover:text-white transition-colors">Monti Floors</Link>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-brand-sand/15 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-sand/50">
          <p>© {new Date().getFullYear()} Monti Home Pros. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p>Serving {business.serviceArea} since {business.since}</p>
            <Link to="/admin" className="text-brand-sand/40 hover:text-brand-clay transition-colors">Staff Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
